import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useCategories(profile: any) {
  const { data: userRole } = useQuery({
    queryKey: ["userRole"],
    queryFn: async () => {
      console.log("Fetching user role for profile:", profile?.id);
      const { data, error } = await supabase
        .from("user_roles")
        .select("role")
        .eq("user_id", profile?.id)
        .maybeSingle();

      if (error) {
        console.error("Error fetching user role:", error);
        throw error;
      }

      console.log("Fetched user role:", data?.role);
      return data?.role;
    },
    enabled: !!profile?.id
  });

  const { data: categories, isLoading: loadingCategories } = useQuery({
    queryKey: ["categories", userRole],
    queryFn: async () => {
      console.log("Fetching categories for role:", userRole);
      let query = supabase.from("artist_categories").select("*");
      
      if (userRole === "recruiter") {
        query = query.eq("is_director_category", true);
      }
      
      const { data, error } = await query;
      
      if (error) {
        console.error("Error fetching categories:", error);
        throw error;
      }
      
      console.log("Fetched categories:", data);
      return data;
    },
    enabled: !!userRole,
  });

  return { categories, loadingCategories };
}